const menu = [
  { type: 'link', label: 'Users',                 link: 'administration/users' },
  { type: 'divider' },
  // { type: 'link', label: 'Colors',                link: 'colors' },

];

export default menu;